import { render, staticRenderFns } from "./Dash-body.vue?vue&type=template&id=400ab3fb"
import script from "./Dash-body.vue?vue&type=script&lang=js"
export * from "./Dash-body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports